import DOMPurify from "dompurify";

export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      "p", "br", "strong", "em", "u", "ol", "ul", "li",
      "h1", "h2", "h3", "h4", "blockquote", "span",
      "a", "img",
    ],
    ALLOWED_ATTR: ["class", "href", "target", "rel", "src", "alt", "title"],
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
  });
}
